import { ApplicationState, AppThunkDispatch } from '../../store';
import { connect } from 'react-redux';
import AlertBar, { AlertBarStateProps, AlertBarDispatchProps } from './AlertBar';
import { alertDismiss } from '../../store/alerts/actions';

const mapStateToProps = (state: ApplicationState): AlertBarStateProps => ({
    alerts: state.alerts.items,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): AlertBarDispatchProps => ({
    dismissAlert: id => dispatch(alertDismiss(id)),
});

export default connect<AlertBarStateProps, AlertBarDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(AlertBar as any);